import api from '@/utils/api';

interface UploadSignatureResponse {
  timestamp: number;
  signature: string;
  folder: string;
  cloudName: string;
  apiKey: string;
}

export interface CloudinaryUploadResult {
  url: string;
  publicId: string;
}

const fetchUploadSignature = async (): Promise<UploadSignatureResponse> => {
  const { data } = await api.get<UploadSignatureResponse>('/api/products/upload/signature');
  return data;
};

const uploadWithSignature = async (
  file: File,
  fetchSignature: () => Promise<UploadSignatureResponse>
): Promise<CloudinaryUploadResult> => {
  const { timestamp, signature, folder, cloudName, apiKey } = await fetchSignature();

  const formData = new FormData();
  formData.append('file', file);
  formData.append('timestamp', String(timestamp));
  formData.append('signature', signature);
  formData.append('folder', folder);
  formData.append('api_key', apiKey);

  const response = await fetch(`https://api.cloudinary.com/v1_1/${cloudName}/image/upload`, {
    method: 'POST',
    body: formData,
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error?.error?.message || 'Image upload failed');
  }

  const payload = await response.json();

  return {
    url: payload.secure_url,
    publicId: payload.public_id,
  };
};

export const uploadProductImage = async (file: File): Promise<CloudinaryUploadResult> => {
  return uploadWithSignature(file, fetchUploadSignature);
};

const fetchCampaignUploadSignature = async (): Promise<UploadSignatureResponse> => {
  const { data } = await api.get<UploadSignatureResponse>('/api/marketing/upload/signature');
  return data;
};

export const uploadCampaignImage = async (file: File): Promise<CloudinaryUploadResult> => {
  return uploadWithSignature(file, fetchCampaignUploadSignature);
};

